module.exports = __webpack_public_path__ + "static/uah_blue-b57180f6b96fd8db45423e50b60487b4.png";